import React from 'react';
import { getParsedDateTime } from '@/util/helper/dateTime';
import { DATE_TIME_FORMAT_MAP } from '@/config/dateTime';
import { BUTTON_SIZE } from '@/config/ui/button';
import { POPUP_HEIGHT } from '@/config/ui/popup';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { BackButton, ForwardButton, MinusButton, PlusButton } from '../../component/atom/Button';
import ChoiceChip from '../../component/atom/ChoiceChip';
import Popup from '../../component/composite/Popup';
import { S } from './style';
import { ALL_DAY_EXPECTED_START_TIME_POPUP_TOTAL_PROGRESS, POPUP_TYPE, } from '../../config/popup';
const getPopupTitle = ({ popupProgress }) => {
    switch (popupProgress) {
        case 1:
            return '請選擇日期';
        case 2:
            return '請選擇時間';
        default:
            throw new Error(`Invalid popup progress: ${popupProgress} in AllDayExpectedStartTime popup`);
    }
};
const renderPopupBodyProgressDate = ({ expectedStartTimeDateOptionList, handleDateChoiceChipClick, getIsDateChoiceChipSelected, }) => {
    const maxDate = expectedStartTimeDateOptionList[expectedStartTimeDateOptionList.length - 1];
    const { parsedDateTime: parsedMaxDate } = getParsedDateTime({
        dateTime: maxDate,
        format: DATE_TIME_FORMAT_MAP.DATE_WITHOUT_DAY,
    });
    return (<>
      <S.LayoutDatesGrid>
        {expectedStartTimeDateOptionList.map((date) => (<ChoiceChip key={date} content={getParsedDateTime({
                dateTime: date,
                format: DATE_TIME_FORMAT_MAP.DATE,
            }).parsedDateTime} onChipClick={() => handleDateChoiceChipClick({ date })} isSelected={getIsDateChoiceChipSelected({ dateOption: date })}/>))}
      </S.LayoutDatesGrid>
      <S.PopupBodyComment>
        ＊目前系統最晚只能派出 {parsedMaxDate} 開始的案件，若需選擇其他日期，請等到可派案時再派出。
        <br />
        ＊開始時間可視您的實際情況修改調整。
      </S.PopupBodyComment>
    </>);
};
const renderPopupBodyProgressTime = ({ expectedStartTime, handleAddButtonClick, handleSubtractButtonClick, getIsAddButtonAvailable, getIsSubtractButtonAvailable, }) => {
    const { parsedDateTime: parsedExpectedStartTimeHour } = getParsedDateTime({
        dateTime: expectedStartTime,
        format: DATE_TIME_FORMAT_MAP.HOUR,
    });
    const { parsedDateTime: parsedExpectedStartTimeMinute } = getParsedDateTime({
        dateTime: expectedStartTime,
        format: DATE_TIME_FORMAT_MAP.MINUTE,
    });
    return (<S.LayoutAlignCenter>
      <S.LayoutTimeSelector>
        <S.TimeSelector>
          <PlusButton size='25px' color={SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_BACKGROUND} isDisabled={!getIsAddButtonAvailable({
            isHour: true,
        })} onButtonClick={() => handleAddButtonClick({ isHour: true })}/>
          {parsedExpectedStartTimeHour}
          <MinusButton size='25px' color={SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_BACKGROUND} isDisabled={!getIsSubtractButtonAvailable({
            isHour: true,
        })} onButtonClick={() => handleSubtractButtonClick({ isHour: true })}/>
        </S.TimeSelector>

        <S.TimeSelectorDivider>:</S.TimeSelectorDivider>

        <S.TimeSelector>
          <PlusButton size='25px' color={SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_BACKGROUND} isDisabled={!getIsAddButtonAvailable({
            isHour: false,
        })} onButtonClick={() => handleAddButtonClick({ isHour: false })}/>
          {parsedExpectedStartTimeMinute}
          <MinusButton size='25px' color={SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_BACKGROUND} isDisabled={!getIsSubtractButtonAvailable({
            isHour: false,
        })} onButtonClick={() => handleSubtractButtonClick({ isHour: false })}/>
        </S.TimeSelector>
      </S.LayoutTimeSelector>
    </S.LayoutAlignCenter>);
};
const renderPopupBody = ({ popupProgress, expectedStartTimeDateOptionList, handleDateChoiceChipClick, expectedStartTime, handleAddButtonClick, handleSubtractButtonClick, getIsDateChoiceChipSelected, getIsAddButtonAvailable, getIsSubtractButtonAvailable, }) => {
    const getPopupBody = () => {
        switch (popupProgress) {
            // Date
            case 1:
                return renderPopupBodyProgressDate({
                    expectedStartTimeDateOptionList,
                    handleDateChoiceChipClick,
                    getIsDateChoiceChipSelected,
                });
            // Time
            case 2:
                return renderPopupBodyProgressTime({
                    expectedStartTime,
                    handleAddButtonClick,
                    handleSubtractButtonClick,
                    getIsAddButtonAvailable,
                    getIsSubtractButtonAvailable,
                });
            default:
                return null;
        }
    };
    return <S.PopupBody>{getPopupBody()}</S.PopupBody>;
};
const renderPopupFooter = ({ popupProgress, setPopupProgress, closePopup, expectedStartTime, }) => {
    const isForwardButtonAvailable = expectedStartTime !== '';
    switch (popupProgress) {
        // Date
        case 1:
            return (<S.PopupFooter>
          <BackButton isAvailable size={BUTTON_SIZE.MEDIUM} onButtonClick={closePopup}>
            返回
          </BackButton>
          <ForwardButton size={BUTTON_SIZE.MEDIUM} isAvailable={isForwardButtonAvailable} onButtonClick={() => setPopupProgress((prev) => prev + 1)}>
            下一步
          </ForwardButton>
        </S.PopupFooter>);
        // Time
        case 2:
            return (<S.PopupFooter>
          <BackButton isAvailable size={BUTTON_SIZE.MEDIUM} onButtonClick={() => setPopupProgress((prev) => prev - 1)}>
            上一步
          </BackButton>
          <ForwardButton size={BUTTON_SIZE.MEDIUM} isAvailable onButtonClick={closePopup}>
            確認
          </ForwardButton>
        </S.PopupFooter>);
        default:
            return null;
    }
};
const resetPopupProgress = ({ setPopupProgress, }) => setPopupProgress(1);
export default function View({ 
// data
popupProgress, expectedStartTimeDateOptionList, popupType, expectedStartTime, 
// func
setPopupProgress, closePopup, handleDateChoiceChipClick, handleAddButtonClick, handleSubtractButtonClick, getIsDateChoiceChipSelected, getIsAddButtonAvailable, getIsSubtractButtonAvailable, }) {
    return (<Popup height={POPUP_HEIGHT.LARGE} title={getPopupTitle({ popupProgress })} currentProgress={popupProgress} totalProgress={ALL_DAY_EXPECTED_START_TIME_POPUP_TOTAL_PROGRESS} isSlideIn={popupType === POPUP_TYPE.ALL_DAY_EXPECTED_START_TIME} closePopup={closePopup} popupBody={renderPopupBody({
            popupProgress,
            expectedStartTimeDateOptionList,
            handleDateChoiceChipClick,
            expectedStartTime,
            handleAddButtonClick,
            handleSubtractButtonClick,
            getIsDateChoiceChipSelected,
            getIsAddButtonAvailable,
            getIsSubtractButtonAvailable,
        })} popupFooter={renderPopupFooter({
            popupProgress,
            setPopupProgress,
            closePopup,
            expectedStartTime,
        })} onSlideOut={() => resetPopupProgress({ setPopupProgress })}/>);
}
